import {createAction, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {CardEditorStore} from "./cardEditorInterface";
import {getActionName} from "../../utils/getActionName";

const sliceName = 'cardEditor';

export const cardEditorInitialState: CardEditorStore = {
    isPlusMenuOpen: false,
    markup: '',
    cardId: undefined,
}

const cardEditorSlice = createSlice({
    name: sliceName,
    initialState: cardEditorInitialState,
    reducers: {
        openPlusMenu(state: CardEditorStore) {
            state.isPlusMenuOpen = true;
        },

        closePlusMenu(state: CardEditorStore) {
            state.isPlusMenuOpen = false;
        },

        setMarkup(state: CardEditorStore, action: PayloadAction<string>) {
            state.markup = action.payload;
        },

        setCardId(state: CardEditorStore, action: PayloadAction<string>) {
            state.cardId = action.payload;
        }
    }
});

export const cardEditorReducer = cardEditorSlice.reducer;

export const cardEditorActions = {
    ...cardEditorSlice.actions,
    loadEditor: createAction<string>(getActionName(sliceName, 'loadEditor')),
    save: createAction(getActionName(sliceName, 'save')),
};
